import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from '../../../api/services/auth.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-resend-otp',
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: './resend-otp.component.html',
  styleUrl: './resend-otp.component.css',
})
export class ResendOtpComponent implements OnInit, OnDestroy {
  @Input() formGroup!: FormGroup;
  @Input() fields: any;
  @Input() workflowData: any;
  isLoading: boolean = false;
  timer: number = 30;
  timerInterval: any = null;

  constructor(
    private authService: AuthService,
    private toaster: ToastrService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.startTimer();
  }

  ngOnDestroy(): void {
    this.stopTimer();
  }

  get formattedTimer(): string {
    return `${this.timer}`;
  }

  startTimer(): void {
    this.stopTimer();
    this.timer = 30;
    this.timerInterval = setInterval(() => {
      if (this.timer > 0) {
        this.timer--;
        this.cdr.detectChanges();
      } else {
        this.stopTimer();
        this.cdr.detectChanges();
      }
    }, 1000);
  }

  stopTimer(): void {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
      this.timerInterval = null;
    }
  }

  resendOtp(): void {
    if (this.isLoading || this.timer > 0) return;
    this.isLoading = true;
    const email =
      this.workflowData?.nodes?.[0]?.previousData?.email ||
      this.workflowData?.nodes?.[0]?.previousData?.username ||
      this.formGroup?.get('email')?.value;

    const payload = {
      email: email,
    };

    this.authService.resendOTP(payload).subscribe({
      next: (res: any) => {
        this.isLoading = false;
        if (res && (res.status === false || res.success === false)) {
          this.cdr.detectChanges();
          this.toaster.error(res.message || 'Failed to resend OTP', 'Error', {
            messageClass: 'addMessage',
            titleClass: 'addCss',
          });
        } else {
          this.startTimer();
          this.cdr.detectChanges();
          this.toaster.success(res?.message || 'OTP resent successfully', 'Success', {
            messageClass: 'addMessage',
            titleClass: 'addCss',
          });
        }
      },
      error: (err: any) => {
        this.isLoading = false;
        this.cdr.detectChanges();
        this.toaster.error(err?.error?.message || err?.message || 'Failed to resend OTP', 'Error', {
          messageClass: 'addMessage',
          titleClass: 'addCss',
        });
      },
    });
  }
}


